import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.0759 0H10.9241C4.8909 0 0 4.8909 0 10.9241V11.0759C0 17.1091 4.8909 22 10.9241 22H11.0759C17.1091 22 22 17.1091 22 11.0759V10.9241C22 4.8909 17.1091 0 11.0759 0Z",
		fill: "#FF241C"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.9996 14.6669C11.6746 14.6669 12.2218 15.2141 12.2218 15.8892C12.2218 16.5642 11.6746 17.1114 10.9996 17.1114C10.3246 17.1114 9.77734 16.5642 9.77734 15.8892C9.77734 15.2141 10.3246 14.6669 10.9996 14.6669ZM10.9996 4.88916C11.6687 4.88916 12.2055 5.44202 12.1858 6.11085L11.9986 12.4746C11.9828 13.0149 11.5401 13.4447 10.9996 13.4447C10.459 13.4447 10.0164 13.0149 10.0005 12.4746L9.81328 6.11085C9.79361 5.44202 10.3304 4.88916 10.9996 4.88916Z",
		fill: "white"
	})]
});
export default SvgNote;
